import React from "react";
import PropTypes from "prop-types";
import {FormControl, InputLabel, Select} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";


const RaikoCustomSelect = (
    {
        labelText,
        value,
        setValue,
        itemsMap,
        items = [],
        onChange
    }) => {

    return (
        <FormControl fullWidth>
            <InputLabel>{labelText}</InputLabel>
            <Select
                value={value}
                label={` ${labelText} `}
                onChange={e => {
                    setValue(e.target.value)
                    if (onChange)
                        onChange(e)
                }}
            >
                {
                    items.map((item, index) => {
                        return <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                    })
                }
            </Select>
        </FormControl>
    )
}

RaikoCustomSelect.propTypes = {
    labelText: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]).isRequired,
    setValue: PropTypes.func.isRequired,
    items: PropTypes.array.isRequired
}

export default RaikoCustomSelect


export function raikoCustomSelectItemGenerator(id, name) {
    return {
        id,
        name
    }
}